import React from "react"
import { RichText as PrismicRichText } from "prismic-reactjs"

import CallToAction from "legacy/components/shared/CallToAction"
import { Element, Text } from "legacy/components/shared/base"
import { ImageAndTextItemType } from "types/shared-components"
import { mapButtonVariant } from "src/legacy/utils"
import RichText from "legacy/components/shared/RichText"

interface OwnProps {
  data: ImageAndTextItemType
  textPadding: string[]
}

export type TextElementsProps = OwnProps

const TextElements: React.FC<TextElementsProps> = ({
  data,
  textPadding,
}): React.ReactElement | null => {
  const { button_color, button_type, button_text, button_url } = data

  return (
    <Element
      display="flex"
      alignItems="flex-start"
      flexDirection="column"
      flexWrap="wrap"
      gridArea="text"
      justifyContent={["flex-start", "flex-start", "center"]}
      maxWidth={["none", "none", "610px"]}
      p={textPadding}
    >
      <Text
        as="h3"
        fontSize={["20", "text.headerSmall"]}
        lineHeight={["25px", "1.4"]}
        maxWidth={["none", "none", "490px"]}
        mb={["15", "40"]}
        variant="headerSmall"
        width="100%"
      >
        {PrismicRichText.asText(data.title?.richText)}
      </Text>
      {data.body_text ? (
        <Text
          as="p"
          fontSize={["17", "text.body"]}
          lineHeight={["28px", "1.8"]}
          variant="body"
        >
          {data.body_text}
        </Text>
      ) : null}
      {data.body_text_wysiwyg ? (
        <RichText render={data.body_text_wysiwyg?.richText} />
      ) : null}
      {button_url && button_text ? (
        <CallToAction
          fontSize={["12", "text.button"]}
          linkType={button_url.link_type}
          mt={["40px", "50px"]}
          sizeVariant={
            data.button_color !== "transparent" ? "default" : "secondary"
          }
          text={button_text}
          type={button_type}
          url={button_url.url}
          variant={mapButtonVariant(button_color)}
        />
      ) : null}
    </Element>
  )
}

export default TextElements
